import React from "react";
import "../../css/StaffHoliday/StaffHoliday.css";

const StaffHolidayEmailPreviewModal = ({ open, onClose, subject, body }) => {
  if (!open) return null;

  return (
    <div className="staff-holiday-modal-backdrop">
      <div className="staff-holiday-modal">
        <div className="staff-holiday-modal-header">
          <div>
            <p className="staff-holiday-eyebrow">Email Preview</p>
            <div className="FP_Content">{subject || "Email Preview"}</div>
          </div>

          <button type="button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="staff-holiday-email-preview">
          <p className="FP_Help_Text grey">
            <strong>Subject:</strong> {subject}
          </p>

          <div className="FP_Content">
            <pre className="FP_Content">{body}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffHolidayEmailPreviewModal;
